module.exports = __webpack_public_path__ + "img/faceberry_facewidth.1fa33501.png";